import XLSX from "xlsx";

export default class Excel {
  /**
   *
   * @param {*} file
   * @param {*} sheetKeyList
   */
  constructor(file, sheetKeyList) {
    this._file = file;
    this._headerKey = sheetKeyList;
    this._sheet = null;
    this._wb = null;
  }

  /**
   * 엑셀 다운로드 시작
   */
  initSheet() {
    this._wb = XLSX.utils.book_new();
  }

  /**
   * 시트 생성 및 추가
   * @param {*} data
   */
  addSheet(data) {
    let headerValue = Object.values(this._headerKey);
    let sheetData = this.changeSheetHeader(data);
    if (this._sheet === null) {
      this._sheet = XLSX.utils.json_to_sheet(sheetData, {
        header: headerValue,
      });
    } else {
      XLSX.utils.sheet_add_json(this._sheet, sheetData, {
        origin: -1,
        skipHeader: true,
        header: headerValue,
      });
    }
  }

  /**
   * 종료
   */
  endSheet(fileName) {
    XLSX.utils.book_append_sheet(this._wb, this._sheet, fileName);
    XLSX.writeFile(this._wb, fileName + ".xlsx");
    this._sheet = null;
    this._wb = null;
  }

  /**
   * 우선 첫번째 시트만 가져옴 json으로 나중에 확장필요하면 하기
   */
  async getJson() {
    let reader = new FileReader();
    reader.readAsBinaryString(this._file);
    let result = await new Promise((resolve) => {
      reader.onload = () => {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, { type: "binary" });
        this._sheetNameList = wb.SheetNames; // 시트 이름 목록 가져오기
        this._firstSheetName = this._sheetNameList[0]; // 첫번째 시트명
        this._firstSheet = wb.Sheets[this._firstSheetName];
        let resultSheet = XLSX.utils.sheet_to_json(this._firstSheet);
        if (this._headerKey) {
          resultSheet = this.changeSheetHeader(resultSheet);
        }

        resolve(resultSheet);
      };
    });
    return result;
  }

  changeSheetHeader(sheet) {
    let result = [];
    sheet.forEach((list) => {
      let data = {};
      for (let k in list) {
        for (let h in this._headerKey) {
          if (h === k) {
            data[this._headerKey[h]] = list[k];
          }
        }
      }
      if (data !== null) {
        result.push(data);
      }
    });
    return result;
  }
}
